import { Badge } from "frontend-components";
import { useTranslation } from "react-i18next";

export function TemplateBadge() {
    const { t } = useTranslation();
    return (
        <Badge
            className="p-1 px-4 text-xs font-normal border-none shadow-none"
            variant="teal-light"
        >
            {t("list.template")}
        </Badge>
    );
}
